import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboInstanceMetricsFilterOptionsResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getDatabaseInstanceMetricsFilterOptions;

export const DBO_INSTANCE_METRICS_FILTER_OPTIONS_QUERY_KEY =
  'dbo-instance-metrics-filter-options';

const getInstanceMetricsFilterOptionsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [DBO_INSTANCE_METRICS_FILTER_OPTIONS_QUERY_KEY, params] as const;

export const useInstanceMetricsFilterOptionsQuery = <
  SELECT = DboInstanceMetricsFilterOptionsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboInstanceMetricsFilterOptionsResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getInstanceMetricsFilterOptionsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
